import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    backoffices: [],
    backofficesMetadata: {},
    backoffice: {},
    backofficeMetadata: {}
  }
})
  .get({
    action: 'getBackoffices',
    property: 'backoffices',
    queryParams: true,
    path: '/backoffices/',
    onSuccess: payloadToState('backoffices')
  })
  .post({
    action: 'createBackoffice',
    property: 'backoffice',
    path: '/backoffice/',
    onSuccess: payloadToState('backoffice')
  })
  .get({
    action: 'getBackoffice',
    property: 'backoffice',
    path: ({ id }) => `/backoffices/${id}`,
    onSuccess: payloadToState('backoffice')
  })
  .put({
    action: 'updateBackoffice',
    property: 'backoffice',
    path: ({ id }) => `/backoffices/${id}`,
    onSuccess: payloadToState('backoffice')
  })
  .delete({
    action: 'deleteBackoffice',
    property: 'backoffice',
    path: ({ id }) => `/backoffices/${id}`,
    beforeRequest: getOptimisticDelete('backoffices'),
    onSuccess: payloadToState('backoffice')
  })
  .getStore()
